import React from 'react';

import { ConfirmDialogUI } from '../Interface';

export const defaultBulkUpdateDialogState = {
  open: false,
  title: '',
  message: '',
  confirmButtonText: 'Sorok módosítása',
  value: null,
  fieldPaths: [],
  setFieldValue: null,
  validateField: null,
};

const BulkUpdateFieldDialog = ({ dialogState, setDialogState }) => {
  const handleClose = () => {
    setDialogState(defaultBulkUpdateDialogState);
  };

  const handleConfirm = async () => {
    const { fieldPaths = [], setFieldValue, validateField, value } = dialogState;

    if (typeof setFieldValue !== 'function' || fieldPaths.length === 0) {
      handleClose();
      return;
    }

    for (const fieldPath of fieldPaths) {
      await setFieldValue(fieldPath, value);
    }

    if (typeof validateField === 'function') {
      for (const fieldPath of fieldPaths) {
        await validateField(fieldPath);
      }
    }

    handleClose();
  };

  return (
    <ConfirmDialogUI
      show={dialogState.open}
      onHide={handleClose}
      handleChangeElement={handleConfirm}
      title={dialogState.title || 'Tömeges módosítás'}
      message={dialogState.message || 'Frissítsük a kapcsolódó sorokat is?'}
      confirmButtonText={dialogState.confirmButtonText}
      disabled={!dialogState.fieldPaths?.length}
      maxWidth="sm"
    />
  );
};

export default BulkUpdateFieldDialog;
